import { render, staticRenderFns } from "./ScreenCarouselPreview.vue?vue&type=template&id=66ebdf5d&scoped=true"
import script from "./ScreenCarouselPreview.vue?vue&type=script&lang=js"
export * from "./ScreenCarouselPreview.vue?vue&type=script&lang=js"
import style0 from "./ScreenCarouselPreview.vue?vue&type=style&index=0&id=66ebdf5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ebdf5d",
  null
  
)

export default component.exports